// @ts-nocheck
export const MODEL_NAME = 'adModal';

export const AD_MODAL_TABLE_IDS = {
	STORES: 50,
	SKUS: 32,
	ENTER_PRICING: 33,
};
export const AD_TYPES_TABLE = 45;
